import React, { Component } from 'react';
import FbrService from '../service/FbrService';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import 'moment';
import 'moment/locale/fr';
import moment from 'moment';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { MultiSelect } from 'primereact/multiselect';
import { Toolbar } from 'primereact/toolbar';

export class FormUtilisateur extends Component {
    constructor() {
        super();
        this.state = {
            listeprest: [],
            listeuser: [],
            listesite: [],
            selectedUser: null,
            idUser: 0,
            pwdUser: '0000',
            dateExpUser: null,
            profilUser: null,
            loginUser: '',
            denregUser: new Date(),
            idPrest: null,
            msg: '',
            modif: false,
            visible: false,
            showindicator: false,

            paramIdUser: '',
            visible_gerer_site: false,
            selectedSites: null,
            modif_gerer_site: false,
            idGererSite: 0,
            liste_gerer_site: [],
            selectedGerersite: null,

            visible_dlg_form: false,
        };
        this.edit_utiisateur = this.edit_utiisateur.bind(this);
        this.conf_delete_utiisateur = this.conf_delete_utiisateur.bind(this);
        this.toogle_actif_user = this.toogle_actif_user.bind(this);
        this.reset_password = this.reset_password.bind(this);

        this.show_dlg_gerer = this.show_dlg_gerer.bind(this);
        this.enreg_gerer_site = this.enreg_gerer_site.bind(this);
        this.act_gerer_site = this.act_gerer_site.bind(this);
        this.toogleDlg = this.toogleDlg.bind(this);
        this.FbrService = new FbrService();

    }

    componentDidMount() {
        this.get_liste_utiisateur();
        this.get_liste_prestataire();
        this.get_liste_site();
    }

    get_liste_site() {
        this.setState({ showindicator: true });
        this.FbrService.get_liste_site().then(data => {
            this.setState({ showindicator: false });
            if (data.length > 0) {
                let liste = data.map(x => {
                    return { value: x.idSite, label: x.nomSite, prefectureSite: x.prefectureSite }
                });
                this.setState({ listesite: liste });
            }
        });
    }

    get_liste_gerer_site() {
        this.FbrService.get_liste_gerer_site_user(this.state.paramIdUser).then(data => this.setState({ liste_gerer_site: data }));
    }

    resultat_gerer_site(code, contenu) {
        if (code == '200') {
            this.toast.show({ severity: 'success', summary: 'Success', detail: contenu });
            this.setState({ modif_gerer_site: false, selectedSites: [] });
            this.get_liste_gerer_site();

            this.componentDidMount();
        } else {
            this.toast.show({ severity: 'error', summary: 'Error', detail: contenu });
        }
        this.setState({ showindicator: false });
    }

    enreg_gerer_site() {
        if (this.state.selectedSites == null || this.state.selectedSites == undefined) {
            this.toast.show({ severity: 'warn', summary: 'Attention', detail: 'Veuillez sélectionner les sites' });
        } else if (this.state.selectedSites.length == 0) {
            this.toast.show({ severity: 'warn', summary: 'Attention', detail: 'Veuillez sélectionner les sites' });
        } else {
            this.setState({ showindicator: true });
            Array.prototype.insert = function (index) {
                this.splice.apply(this, [index, 0].concat(this.slice.call(arguments, 1)));
            };
            if (this.state.modif_gerer_site == false) {
                this.setState({ showindicator: true });
                var data_value = [];
                let userconnected = this.FbrService.get_userconnected();
                for (var i = 0; i < this.state.selectedSites.length; i++) {
                    var obj = { actifGererSite: 'Oui', idSite: { idSite: this.state.selectedSites[i] }, idUser: this.state.selectedUser, iduser: userconnected.idUser };
                    obj.idGererSite = 0;
                    data_value.push(obj);
                }
                this.FbrService.enreg_gerer_site_bulk(data_value).then(data => this.resultat_gerer_site(data.code, data.contenu));
            } else {
                let data = this.state.selectedGerersite;
                if (this.state.selectedGerersite.actifGererSite == 'Oui') {
                    data.actifGererSite = 'Non';
                } else {
                    data.actifGererSite = 'Oui';
                }
                this.setState({ showindicator: true });
                this.FbrService.enreg_gerer_site(data).then(data => this.resultat_gerer_site(data.code, data.contenu));
            }
        }
    }

    act_gerer_site(selected_data) {
        if (selected_data.actifGererSite == 'Oui') {
            selected_data.actifGererSite = 'Non';
        } else {
            selected_data.actifGererSite = 'Oui';
        }
        this.FbrService.enreg_gerer_site(selected_data).then(data => this.resultat_gerer_site(data.code, data.contenu));
    }

    actionTemplate_gerer_site(rowData, column) {
        if (rowData.actifGererSite == 'Oui') {
            return <Button title="Désactiver" onClick={(e) => this.act_gerer_site(rowData)} className="p-button-success" style={{ width: 25, height: 25 }} icon="pi pi-check" />
        } else {
            return <Button title="Activer" onClick={(e) => this.act_gerer_site(rowData)} className="p-button-danger" style={{ width: 25, height: 25 }} icon="pi pi-check" />
        }
    }

    show_dlg_gerer(data) {
        if (data !== null && data !== undefined) {
            this.setState({ selectedUser: data });
            this.setState({ paramIdUser: data.idUser }, () => {
                this.get_liste_gerer_site();
            });
            this.setState({ msg: data.loginUser });
            this.setState({ visible_gerer_site: true });
        }
    }


    get_liste_utiisateur() {
        this.setState({ showindicator: true });
        this.FbrService.get_liste_user().then(data => this.setState({ listeuser: data, showindicator: false }));
    }

    getParent(id, data) {
        let nom = '';
        if (data !== null && data !== undefined) {
            let liste = data.filter(function (el) {
                return el.idPrest == id;
            });
            if (liste !== null && liste !== undefined) {
                nom = liste[0].nomPrest;
            }
        }
        return nom;
    }

    get_liste_prestataire() {
        this.setState({ showindicator: true });
        this.FbrService.get_liste_prestataire().then(data => this.setState({ showindicator: false }, () => {
            if (data !== null && data !== undefined) {
                let listeprest = data;
                for (var i = listeprest.length; i--;) {
                    listeprest[i].nomPrestParent = this.getParent(listeprest[i].idPrestParent, data);
                }
                this.setState({ listeprest: listeprest });
            }
        }));
    }


    resultat(code, contenu) {
        if (code == '200') {
            this.toast.show({ severity: 'success', summary: 'Success', detail: contenu });
            this.annule_utiisateur();
            this.componentDidMount();
        } else {
            this.toast.show({ severity: 'error', summary: 'Error', detail: contenu });
        }
        this.setState({ showindicator: false });
    }

    edit_utiisateur(data) {
        if (data != null && data != undefined) {
            this.setState({ idUser: data.idUser });
            this.setState({ profilUser: data.profilUser });
            this.setState({ loginUser: data.loginUser });
            this.setState({ pwdUser: data.pwdUser });
            this.setState({ denregUser: data.denregUser });
            this.setState({ idPrest: data.idPrest.idPrest });
            this.setState({ dateExpUser: new Date(moment(data.dateExpUser, 'YYYY-MM-DD').format('YYYY-MM-DD')) });
            this.setState({ modif: true });
            this.setState({ selectedUser: data });
            this.setState({ visible_dlg_form: true });
            window.scrollTo(0, 0);
        }
    }

    reset_password(rowData) {
        if (rowData === null || rowData === undefined) {
            this.toast.show({ severity: 'warn', summary: 'Attention', detail: 'Veuillez sélectionner la ligne à modifier' });
        } else {
            rowData.pwdUser = '0000';
            rowData.changerPwd = 'Oui';
            this.setState({ showindicator: true });
            this.FbrService.reset_password(rowData).then(data => {
                if (data !== null && data !== undefined) {
                    if (data.code === 200) {
                        this.toast.show({ severity: 'success', summary: 'Success', detail: 'Reinitialisation effectuée avec succès' });
                    } else {
                        this.toast.show({ severity: 'error', summary: 'Error', detail: 'Echec reinitialisation' });
                    }
                }
                this.setState({ showindicator: false });
            });
        }
    }

    toogle_actif_user(rowData) {
        if (rowData === null || rowData === undefined) {
            this.toast.show({ severity: 'warn', summary: 'Attention', detail: 'Veuillez sélectionner la ligne à modifier' });
        } else {
            if (rowData.actifUser == 'Oui') {
                rowData.actifUser = 'Non';
            } else {
                rowData.actifUser = 'Oui';
            }
            this.setState({ showindicator: true });
            this.FbrService.reset_password(rowData).then(data => {
                if (data !== null && data !== undefined) {
                    if (data.code === 200) {
                        this.toast.show({ severity: 'success', summary: 'Success', detail: 'Reinitialisation effectuée avec succès' });
                    } else {
                        this.toast.show({ severity: 'error', summary: 'Error', detail: 'Echec reinitialisation' });
                    }
                }
                this.setState({ showindicator: false });
            });
        }
    }

    annule_utiisateur() {
        this.setState({ profilUser: '' });
        this.setState({ loginUser: '' });
        this.setState({ idPrest: '' });
        this.setState({ idUser: 0 });
        this.setState({ modif: false, visible_dlg_form: false });
        this.forceUpdate();
    }

    enreg_utiisateur() {
        if (this.state.loginUser == "" || this.state.profilUser == "" || this.state.idPrest == "" || this.state.dateExpUser == "") {
            this.toast.show({ severity: 'warn', summary: 'Attention', detail: 'Veuillez saisir tous les champs obligatoires' });
        } else {
            this.setState({ showindicator: true });
            if (this.state.modif == false) {
                let utilisateur = {
                    idUser: 0,
                    dateExpUser: moment(this.state.dateExpUser, 'DD/MM/YYYY').format('DD/MM/YYYY'),
                    loginUser: this.state.loginUser,
                    profilUser: this.state.profilUser,
                    pwdUser: this.state.pwdUser,
                    actifUser: 'Oui',
                    changerPwd: 'Oui',
                    idPrest: { idPrest: this.state.idPrest }
                }
                this.FbrService.enreg_user(utilisateur).then(data => this.resultat(data.code, data.contenu));
            } else {
                let utilisateur = this.state.selectedUser;
                utilisateur.dateExpUser = moment(this.state.dateExpUser, 'DD/MM/YYYY').format('DD/MM/YYYY');
                utilisateur.loginUser = this.state.loginUser;
                utilisateur.profilUser = this.state.profilUser;
                this.FbrService.enreg_user(utilisateur).then(data => this.resultat(data.code, data.contenu));
            }
        }
    }

    actionTemplate(rowData) {
        let label = 'Activer';
        if (rowData.actifUser == 'Oui') {
            label = 'Désactiver';
        }
        let items = [
            {
                label: 'Supprimer',
                icon: 'pi pi-times',
                command: (e) => {
                    this.conf_delete_utiisateur(rowData);
                }
            },
            {
                label: 'Modifier',
                icon: 'pi pi-pencil',
                command: (e) => {
                    this.edit_utiisateur(rowData);
                }
            },
            {
                label: 'Réinitialiser',
                icon: 'pi pi-refresh',
                command: (e) => {
                    this.reset_password(rowData);
                }
            },
            {
                label: label,
                icon: 'pi pi-lock',
                command: (e) => {
                    this.toogle_actif_user(rowData);
                }
            },
            {
                label: 'Affectation',
                icon: 'pi pi-sitemap',
                command: (e) => {
                    this.show_dlg_gerer(rowData);
                }
            }
        ]
        return <SplitButton className='p-button-info' onClick={(e) => this.edit_utiisateur(rowData)} icon="pi pi-pencil" style={{ width: 80 }} model={items}></SplitButton>
    }


    delete_utiisateur() {
        if (this.state.selectedUser == null || this.state.selectedUser == undefined) {
            this.toast.show({ severity: 'warn', summary: 'Attention', detail: 'Veuillez sélectionner la ligne à supprimer' });
        } else {
            this.setState({ showindicator: true });
            this.FbrService.delete_user(this.state.selectedUser).then(data => this.resultat(data.code, data.contenu));
        }
    }


    conf_delete_utiisateur(data) {
        if (data != null && data != undefined) {
            this.setState({ selectedUser: data });
            this.setState({ msg: data.loginUser });
            this.setState({ visible: true });
        }
    }

    exportCSV = () => {
        this.dt.exportCSV();
    }

    itemTemplate(option) {
        if (!option.value) {
            return option.label;
        }
        else {
            return (
                <div className="clearfix">
                    <div className="grid">
                        <div className="col-12 md:col-6">
                            <label>{option.label}</label>
                        </div>
                        <div className="col-12 md:col-6">
                            <label>{option.nomPrestParent}</label>
                        </div>
                    </div>
                </div>
            );
        }
    }


    itemTemplateSite(option) {
        if (!option.value) {
            return option.label;
        }
        else {
            return (
                <label>{option.label} / {option.prefectureSite}</label>
            );
        }
    }

    toogleDlg() {
        this.setState({ visible_dlg_form: !this.state.visible_dlg_form });
    }

    leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Nouveau" icon="pi pi-plus" className="p-button-success mr-2" style={{ width: 120 }} onClick={this.toogleDlg} />
                <Button label="Supprimer" disabled={this.state.selectedUser == null} icon="pi pi-trash" className="p-button-danger" onClick={(e) => this.conf_delete_utiisateur(this.state.selectedUser)} style={{ width: 115 }} />
            </React.Fragment>
        )
    }

    rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                {this.state.showindicator ? <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" fill="#EEEEEE" animationDuration=".5s" /> : <Button label="Export" icon="pi pi-download" className="p-button-help" onClick={this.exportCSV} />}
            </React.Fragment>
        )
    }


    render() {

        let prestataire
        if (this.state.listeprest.length > 0) {
            let liste = this.state.listeprest.filter(function (el) {
                return el.typePrest.libCodif == 'PERSONNE';
            });
            if (liste !== null && liste !== undefined) {
                prestataire = liste.map(x => {
                    return { value: x.idPrest, label: x.nomPrest, nomPrestParent: x.nomPrestParent }
                });
            }
        }
        let liste_profil = [
            { label: 'Administrateur', value: 'Administrateur' },
            { label: 'Superviseur', value: 'Superviseur' },
            { label: 'Payeur', value: 'Payeur' },
            { label: 'OBC', value: 'OBC' },
            { label: 'Prestataire', value: 'Prestataire' },
            { label: 'Gestionnaire données', value: 'Gestionnaire données' },
            { label: 'Consultation', value: 'Consultation' },
        ];

       
        const dialogFooter = (
            <div>
                <Button icon="pi pi-check" onClick={() => {
                    this.setState({ visible: false });
                    this.delete_utiisateur();
                }} label="Oui" />
                <Button icon="pi pi-times" onClick={() => this.setState({ visible: false })} label="Annuler" className="p-button-secondary" />
            </div>
        );
        return (
            <div className="p-fluid card" style={{ minHeight: 1000 }}>
                <Toast ref={(el) => this.toast = el} />

                <Toolbar style={{ paddingBlock: 5 }} className="mb-4" left={this.leftToolbarTemplate} right={this.rightToolbarTemplate}></Toolbar>


                <Dialog header="Confirmation" visible={this.state.visible} style={{ width: '250px' }} modal={true} footer={dialogFooter} onHide={() => this.setState({ visible: false })}>
                    <div>
                        <i className="fa fa-warning" style={{ color: '#FFD133', fontSize: 25 }}></i>
                        Voulez vous vraiment supprimer <b>{this.state.msg} </b>?
                    </div>
                </Dialog>

                <Dialog header="Sites rattachés" visible={this.state.visible_gerer_site} style={{ width: '60%' }} modal={true} onHide={(e) => this.setState({ visible_gerer_site: false })}>
                    <div className="grid">
                        <div className="col-12">
                            <div className="card card-w-title" style={{ height: 450 }}>
                                <div className="grid">
                                    <div className="col-12 md:col-2">
                                        <label htmlFor="profile">Sites *</label>
                                    </div>
                                    <div className="col-12 md:col-7">
                                        <MultiSelect options={this.state.listesite} display="chip" value={this.state.selectedSites} onChange={(e) => this.setState({ selectedSites: e.value })} optionLabel="label" filter={true} filterBy='label,prefectureSite' filterMatchMode='contains' placeholder="Selectionner les sites" autoWidth={false} appendTo={document.body} itemTemplate={this.itemTemplateSite} style={{ width: '100%' }} />
                                    </div>
                                    <div className="col-12 md:col-2">
                                        <Button label="Ajouter" icon="pi pi-check" onClick={(e) => this.enreg_gerer_site()} />
                                    </div>
                                    <div className="col-12 md:col-1">
                                        {this.state.showindicator ? <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" fill="#EEEEEE" animationDuration=".5s" /> : null}
                                    </div>
                                </div>
                                <DataTable value={this.state.liste_gerer_site} selectionMode="single" paginator={true} rows={10} alwaysShowPaginator={false}
                                    onRowClick={e => this.setState({ selectedGerersite: e.data })} onRowSelect={e => this.setState({ selectedGerersite: e.data })}
                                    responsive={true} selection={this.state.selectedGerersite} className="p-datatable-gridlines p-datatable-striped p-datatable-md p-datatable-customers"  >
                                    <Column header="#" body={this.actionTemplate_gerer_site.bind(this)} style={{ width: '7%' }} />
                                    <Column field="idSite.nomSite" header="Nom site" filter={true} filterMatchMode='contains' sortable={true} />
                                    <Column field="idSite.prefectureSite" header="Zone santé" style={{ width: '20%' }} filter={true} filterMatchMode='contains' sortable={true} />
                                    <Column field="idSite.crdSite" header="CR" style={{ width: '20%' }} filter={true} filterMatchMode='contains' sortable={true} />
                                    <Column field="idSite.regionSite" header="Province" style={{ width: '20%' }} filter={true} filterMatchMode='contains' sortable={true} />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </Dialog>


                <DataTable value={this.state.listeuser} paginatorPosition="top" selectionMode="single" paginator={true} rows={20} responsiveLayout='scroll'
                    alwaysShowPaginator={false} onRowClick={e => this.setState({ selectedUser: e.data })} onRowSelect={e => this.setState({ selectedUser: e.data })} ref={(el) => { this.dt = el; }}
                    responsive={true} selection={this.state.selectedUser} className="p-datatable-gridlines p-datatable-striped p-datatable-md p-datatable-customers" >
                    <Column header="Action" body={this.actionTemplate.bind(this)} style={{ width: '10%' }} />
                    <Column field="idPrest.nomPrest" filter={true} filterMatchMode='contains' header="Titulaire" sortable={true} />
                    <Column field="profilUser" filter={true} filterMatchMode='contains' header="Profil" sortable={true} style={{ width: '17%' }} />
                    <Column field="idPrest.telPrest" filter={true} filterMatchMode='contains' header="Téléphone" sortable={true} style={{ width: '12%' }} />
                    <Column field="loginUser" filter={true} filterMatchMode='contains' header="Login" sortable={true} style={{ width: '15%' }} />
                    <Column field="dateExpUser" filter={true} filterMatchMode='contains' header="Expiration" sortable={true} style={{ width: '11%' }} />
                    <Column field="actifUser" filter={true} filterMatchMode='contains' header="Actif" sortable={true} style={{ width: '8%' }} />
                </DataTable>

                <Dialog visible={this.state.visible_dlg_form} style={{ width: '70%' }} header={this.state.modif == true ? "Modification" : "Nouveau utilisateur"} modal className="p-fluid" onHide={(e) => this.setState({ visible_dlg_form: false })}
                    footer={
                        <>
                            <Button label="Annuler" icon="pi pi-times" className="p-button-secondary" style={{ width: 120 }} onClick={(e) => this.annule_utiisateur()} />
                            <Button label="Terminer" loading={this.state.showindicator} icon="pi pi-check" onClick={(e) => this.enreg_utiisateur()} style={{ width: 120 }} />
                        </>
                    }>
                    <div className="card">
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-2">
                                <label htmlFor="idPrest">Titulaire *</label>
                            </div>
                            <div className="field col-12 md:col-4">
                                <Dropdown value={this.state.idPrest} options={prestataire} optionLabel='label' filter={true} filterMatchMode='contains' filterBy='label,nomPrestParent' onChange={(e) => this.setState({ idPrest: e.target.value })} autoWidth={false} panelStyle={{ width: '500px' }} itemTemplate={this.itemTemplate} />
                            </div>
                            <div className="field col-12 md:col-2">
                                <label htmlFor="loginUser">Login *</label>
                            </div>
                            <div className="field col-12 md:col-4">
                                <InputText id="loginUser" value={this.state.loginUser} onChange={(e) => this.setState({ loginUser: e.target.value })} />
                            </div>
                            <div className="field col-12 md:col-2">
                                <label htmlFor="profilUser">Profil *</label>
                            </div>
                            <div className="field col-12 md:col-4">
                                <Dropdown value={this.state.profilUser} options={liste_profil} onChange={(e) => this.setState({ profilUser: e.target.value })} autoWidth={false} optionLabel='label' filter={true} filterBy='label' filterMatchMode='contains' />
                            </div>
                            <div className="field col-12 md:col-2">
                                <label htmlFor="dateRgl">Date expiration *</label>
                            </div>
                            <div className="field col-12 md:col-4">
                                <Calendar id="dateRgl" dateFormat="dd/mm/yy" value={this.state.dateExpUser} onChange={(e) => this.setState({ dateExpUser: e.target.value })} yearNavigator monthNavigator yearRange='2019:2050'/>
                            </div>

                        </div>
                    </div>
                </Dialog>
            </div>

        );
    }
}